import { SUCCESS, FETCH_WHOS_HERE } from '../constants/actionApi';
import { addOrUpdateItemsInState } from '../helpers/data';
import initialState from '../store/initialState';

export default (state = initialState.whosHere, { type, payload }) => {
  switch (type) {
    case FETCH_WHOS_HERE + SUCCESS:
      return addOrUpdateItemsInState(state, payload.data);
    default:
      return state;
  }
};
